import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  fileUrls: '',
};

const fileUrlsSlice = createSlice({
  name: 'fileUrls',
  initialState,
  reducers: {
    setFileUrls: (state, action) => {
      state.fileUrls = action.payload;
    },
    clearFileUrls: (state) => {
      state.fileUrls = '';
    },
  },
});

export const { setFileUrls, clearFileUrls } = fileUrlsSlice.actions;
export default fileUrlsSlice.reducer;
